import { CompetitionCard } from "../../Competitions/Hub/CompetitionCard";
import { FeaturedCompetition } from "./FeaturedCompetition";
import { CompetitionsBannerViewModel } from "./ViewModel";
import {
  SectionWrapper,
  MoreWrap,
  MoreHeading,
  MoreRow,
} from "./styledComponents";

export const CompetitionsBanner = () => {
  const { featured, others, loading } = CompetitionsBannerViewModel();

  if (loading || (!featured && others.length === 0)) return null;

  return (
    <SectionWrapper>
      {featured && <FeaturedCompetition competition={featured} />}

      {others.length > 0 && (
        <MoreWrap>
          <MoreHeading>Check out more competitions</MoreHeading>
          <MoreRow>
            {others.map((competition) => (
              <CompetitionCard
                key={competition._id}
                competition={competition}
              />
            ))}
          </MoreRow>
        </MoreWrap>
      )}
    </SectionWrapper>
  );
};
